<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <template v-if="isIdoso">
                    <div class="animate__animated animate__fadeIn">
                        <div class="row">
                            <div class="col-12">
                                <h4 class="font-weight-bold">
                                    Objetivos e Metas
                                </h4>
                            </div>
                        </div>
                        <div class="row px-3">
                            <ul class="nav nav-pills flex-column col-md-3 px-0">
                                <li class="nav-item mb-2">
                                    <a
                                        @click="aba = 'documental'"
                                        :class="aba == 'documental' ? 'active' : ''"
                                        class="list-group-item nav-link list-group-item-action"
                                        >Situação Documental</a
                                    >
                                </li>
                                <li class="nav-item mb-2">
                                    <a
                                        class="list-group-item nav-link list-group-item-action"
                                        @click="aba = 'processual'"
                                        :class="aba == 'processual' ? 'active' : ''"
                                        >Situação Processual</a
                                    >
                                </li>
                                <li class="nav-item mb-2">
                                    <a
                                        class="list-group-item nav-link list-group-item-action"
                                        @click="aba = 'saude'"
                                        :class="aba == 'saude' ? 'active' : ''"
                                        >Saúde</a
                                    >
                                </li>
                                <li class="nav-item mb-2">
                                    <a
                                        class="list-group-item nav-link list-group-item-action"
                                        @click="aba = 'educacao'"
                                        :class="aba == 'educacao' ? 'active' : ''"
                                        >Educação</a
                                    >
                                </li>
                                <li class="nav-item mb-2">
                                    <a
                                        class="list-group-item nav-link list-group-item-action"
                                        @click="aba = 'profissionalizacao'"
                                        :class="
                                            aba == 'profissionalizacao'
                                                ? 'active'
                                                : ''
                                        "
                                        >Profissionalização</a
                                    >
                                </li>
                                <li class="nav-item mb-2">
                                    <a
                                        class="list-group-item nav-link list-group-item-action"
                                        @click="aba = 'arte'"
                                        :class="aba == 'arte' ? 'active' : ''"
                                        >Arte, Cultura, Esporte E Lazer</a
                                    >
                                </li>
                                <li class="nav-item mb-2">
                                    <a
                                        class="list-group-item nav-link list-group-item-action"
                                        @click="aba = 'aspecto'"
                                        :class="aba == 'aspecto' ? 'active' : ''"
                                        >Aspectos Sociofamiliares</a
                                    >
                                </li>
                                <li class="nav-item mb-2">
                                    <a
                                        class="list-group-item nav-link list-group-item-action"
                                        @click="aba = 'condicao'"
                                        :class="aba == 'condicao' ? 'active' : ''"
                                        >Condições Socioeconômicas
                                    </a>
                                </li>
                                <li class="nav-item mb-2">
                                    <a
                                        class="list-group-item nav-link list-group-item-action"
                                        @click="aba = 'vulnerabilidade'"
                                        :class="
                                            aba == 'vulnerabilidade' ? 'active' : ''
                                        "
                                        >Vulnerabilidade e Riscos</a
                                    >
                                </li>
                                <li class="nav-item mb-2">
                                    <a
                                        class="list-group-item nav-link list-group-item-action"
                                        @click="aba = 'autonomia'"
                                        :class="aba == 'autonomia' ? 'active' : ''"
                                        >Autonomia / autoestima / identidade
                                    </a>
                                </li>
                                <li class="nav-item mb-2">
                                    <a
                                        class="list-group-item nav-link list-group-item-action"
                                        @click="aba = 'preparacao'"
                                        :class="aba == 'preparacao' ? 'active' : ''"
                                        >Preparação para desligamento</a
                                    >
                                </li>
                            </ul>
                            <div class="col-md-9">
                                <div v-show="aba == 'documental'">
                                    <div class="row">
                                        <h4 class="px-3">Situação Documental</h4>
                                        <form-calendar
                                            label="Prazo"
                                            v-model="metaIdoso.idoso.documental_prazo"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="
                                                metaIdoso.idoso.documental_situacao_atual
                                            "
                                            label="Situação Atual"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.documental_meta"
                                            label="Objetivo/Meta"
                                        />
                                    </div>
                                </div>
                                <div v-show="aba == 'processual'">
                                    <div class="row">
                                        <h4 class="px-3">Situação Processual</h4>
                                        <form-calendar
                                            label="Prazo"
                                            v-model="metaIdoso.idoso.processual_prazo"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="
                                                metaIdoso.idoso.processual_situacao_atual
                                            "
                                            label="Situação Atual"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.processual_meta"
                                            label="Objetivo/Meta"
                                        />
                                    </div>
                                </div>
                                <div v-show="aba == 'saude'">
                                    <div class="row">
                                        <h4 class="px-3">Saúde</h4>
                                        <form-calendar
                                            label="Prazo"
                                            v-model="metaIdoso.idoso.saude_prazo"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.saude_situacao_atual"
                                            label="Situação Atual"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.saude_meta"
                                            label="Objetivo/Meta"
                                        />
                                    </div>
                                </div>
                                <div v-show="aba == 'educacao'">
                                    <div class="row">
                                        <h4 class="px-3">Educação</h4>
                                        <form-calendar
                                            label="Prazo"
                                            v-model="metaIdoso.idoso.educacao_prazo"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="
                                                metaIdoso.idoso.educacao_situacao_atual
                                            "
                                            label="Situação Atual"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.educacao_meta"
                                            label="Objetivo/Meta"
                                        />
                                    </div>
                                </div>
                                <div v-show="aba == 'profissionalizacao'">
                                    <div class="row">
                                        <h4 class="px-3">Profissionalização</h4>
                                        <form-calendar
                                            label="Prazo"
                                            v-model="
                                                metaIdoso.idoso.profissionalizacao_prazo
                                            "
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="
                                                metaIdoso.idoso.profissionalizacao_situacao_atual
                                            "
                                            label="Situação Atual"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="
                                                metaIdoso.idoso.profissionalizacao_meta
                                            "
                                            label="Objetivo/Meta"
                                        />
                                    </div>
                                </div>
                                <div v-show="aba == 'arte'">
                                    <div class="row">
                                        <h4 class="px-3">
                                            Arte, Cultura, Esporte E Lazer
                                        </h4>
                                        <form-calendar
                                            label="Prazo"
                                            v-model="metaIdoso.idoso.arte_prazo"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.arte_situacao_atual"
                                            label="Situação Atual"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.arte_meta"
                                            label="Objetivo/Meta"
                                        />
                                    </div>
                                </div>
                                <div v-show="aba == 'aspecto'">
                                    <div class="row">
                                        <h4 class="px-3">
                                            Aspectos Sociofamiliares
                                        </h4>
                                        <form-calendar
                                            label="Prazo"
                                            v-model="metaIdoso.idoso.aspecto_prazo"
                                        />
                                        <form-select
                                            v-model="metaIdoso.idoso.possui_rede_apoio"
                                            :itens="$root.arrays.pergunta"
                                            label="Possui rede de apoio (pessoas/grupos que prestam algum tipo de suporte)?"
                                        />
                                    </div>

                                    <form @submit.prevent="cadastarPessoaReferencia" ref="addItem">
                                        <div class="row">
                                            <form-input 
                                                v-model="nome" 
                                                label="Nome Completo" 
                                                :required="true" 
                                            />
                                            <form-input
                                                v-model="parentesco"
                                                label="Parentesco / Tipo de Relação"
                                                grid="6"
                                                :required="true"
                                            />
                                            <form-input 
                                                label="Idade" 
                                                v-model="idade" 
                                                type="number"
                                                grid="6"
                                            />
                                            <form-input
                                                v-model="telefone"
                                                label="Telefone"
                                                v-mask="'(##) # ####-####'"
                                                placeholder="(00) 0 0000-0000"
                                                grid="6"
                                            />
                                            <form-input 
                                                label="E-mail" 
                                                v-model="email" 
                                                type="text"
                                                grid="6"
                                            />
                                            <form-input 
                                                label="Endereço" 
                                                v-model="endereco" 
                                                type="text"
                                            />
                                            <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end">
                                                <button class="btn btn-primary m-0" data-style="zoom-in" type="submit">
                                                    Cadastrar
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                        
                                    <div class="row">
                                        <div class="col-12" v-if="pessoaReferencia.filter(p => p.tipo_cadastro === 'Sociofamiliar').length > 0">
                                            <label class="d-block font-weight-bold mb-3">
                                                Relação de Sociofamiliares: 
                                            </label>

                                            <table class="table table-sm border table-bordered mb-3" v-for="(pessoa, index) in pessoaReferencia.filter(p => p.tipo_cadastro === 'Sociofamiliar')">
                                                <tbody>
                                                    <tr>
                                                        <td class="py-0" colspan="2">
                                                            Nome Completo: <b>{{ pessoa.nome }}</b>
                                                            <a
                                                                title="Excluir"
                                                                @click="excluirPessoa(pessoa.id, index)"
                                                                class="float-right px-2 mb-0 text-danger "
                                                            >
                                                                <i class="mdi mdi-close"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="py-0">
                                                            Parentesco/ posição Familiar:
                                                            <b>{{ pessoa.parentesco }}</b>
                                                        </td>
                                                        <td class="py-0">
                                                            Idade:
                                                            <b>{{ pessoa.idade }}</b>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-12" v-else>
                                            <h4 class="text-secondary">
                                                <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                                                Nada salvo aqui.
                                            </h4>
                                        </div>
                                        <form-input
                                            v-model="metaIdoso.idoso.intervencoes_sociofamiliares"
                                            label="Intervenção e Percepção do Profissional referente aos aspectos sociofamiliares"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.text_equipe_suas"
                                            label="Percepção da equipe SUAS"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.aspecto_situacao_atual"
                                            label="Situação Atual"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.aspecto_meta"
                                            label="Objetivo/Meta"
                                        />
                                    </div>
                                </div>
                                <div v-show="aba == 'condicao'">
                                    <div class="row">
                                        <h4 class="px-3">
                                            Condições Socioeconômicas
                                        </h4>
                                        <form-calendar
                                            label="Prazo"
                                            v-model="metaIdoso.idoso.condicao_prazo"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="
                                                metaIdoso.idoso.condicao_situacao_atual
                                            "
                                            label="Situação Atual"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.condicao_meta"
                                            label="Objetivo/Meta"
                                        />
                                    </div>
                                </div>
                                <div v-show="aba == 'vulnerabilidade'">
                                    <div class="row">
                                        <h4 class="px-3">
                                            Vulnerabilidade e Riscos
                                        </h4>
                                        <form-calendar
                                            label="Prazo"
                                            v-model="
                                                metaIdoso.idoso.vulnerabildiade_prazo
                                            "
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="
                                                metaIdoso.idoso.vulnerabildiade_situacao_atual
                                            "
                                            label="Situação Atual"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.vulnerabildiade_meta"
                                            label="Objetivo/Meta"
                                        />
                                    </div>
                                </div>
                                <div v-show="aba == 'autonomia'">
                                    <div class="row">
                                        <h4 class="px-3">
                                            Autonomia / autoestima / identidade
                                        </h4>
                                        <form-calendar
                                            label="Prazo"
                                            v-model="metaIdoso.idoso.autonomia_prazo"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="
                                                metaIdoso.idoso.autonomia_situacao_atual
                                            "
                                            label="Situação Atual"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.autonomia_meta"
                                            label="Objetivo/Meta"
                                        />
                                    </div>
                                </div>
                                <div v-show="aba == 'preparacao'">
                                    <div class="row">
                                        <h4 class="px-3">
                                            Preparação para desligamento
                                        </h4>
                                        <form-calendar
                                            label="Prazo"
                                            v-model="metaIdoso.idoso.desligamento_prazo"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="
                                                metaIdoso.idoso.desligamento_situacao_atual
                                            "
                                            label="Situação Atual"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.desligamento_meta"
                                            label="Objetivo/Meta"
                                        />
                                        <form-input
                                            v-model="metaIdoso.idoso.data_desligamento"
                                            label="Data do Desligamento"
                                            grid="6"
                                            type="date"
                                        />
                                        <form-select
                                            v-model="metaIdoso.idoso.motivo_desligamento"
                                            :itens="$root.arrays.motivo_desligamento_acolhimento"
                                            label="Motivo do Desligamento"
                                            grid="6"
                                        />
                                        <form-input
                                            v-model="metaIdoso.idoso.desc_motivo_desligamento"
                                            label="Descreva o motivo do desligamento"
                                            type="text"
                                            v-show="mostrarDescDesligamento"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.dados_da_rede_socioassistencial"
                                            label="Dados da rede socioassistencial e intersetorial para acompanhamento: local(s), serviço(s), programa(s)"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.acao_repactuada"
                                            label="Ações pactuadas no período pós-acolhimento e prazo(s)"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.rede_apoio_contato"
                                            label="Rede de apoio para contato"
                                        />
                                        <form-textarea-editor
                                            class="mt-3"
                                            v-model="metaIdoso.idoso.observacoes_desligamento"
                                            label="Observações"
                                        />
                                    </div>
                                </div>
                                <div class="row px-2 d-flex justify-content-end">
                                    <button
                                        class="btn btn-success btn-submit"
                                        data-style="zoom-in"
                                        @click="submit"
                                        type="submit"
                                    >
                                        <i class="mdi mdi-content-save" />
                                        {{ $t("Salvar") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <template v-else>
                    <div class="row">
                        <div class="col-12">
                            <h3>Pessoas Vinculadas ao Acolhimento:</h3>

                            <b-table :items="todasPessoas" :fields="['nome', 'idade', 'parentesco']" small responsive>
                                <template #cell(nome)="row">
                                    <a href="#" @click.prevent="selecionarPessoa(row.item)">
                                    {{ row.item.nome }}
                                    </a>
                                </template>
                            </b-table>

                            <div v-if="pessoaSelecionada">

                                <br/>
                                <br/>

                                <h3>Objetivos e Metas de: {{ pessoaSelecionada.nome }}</h3>

                                <div class="row px-3">
                                    <ul class="nav nav-pills flex-column col-md-3 px-0">
                                        <li class="nav-item mb-2">
                                            <a
                                                @click="aba = 'documental'"
                                                :class="aba == 'documental' ? 'active' : ''"
                                                class="list-group-item nav-link list-group-item-action"
                                                >Situação Documental</a
                                            >
                                        </li>
                                        <li class="nav-item mb-2">
                                            <a
                                                class="list-group-item nav-link list-group-item-action"
                                                @click="aba = 'processual'"
                                                :class="aba == 'processual' ? 'active' : ''"
                                                >Situação Processual</a
                                            >
                                        </li>
                                        <li class="nav-item mb-2">
                                            <a
                                                class="list-group-item nav-link list-group-item-action"
                                                @click="aba = 'saude'"
                                                :class="aba == 'saude' ? 'active' : ''"
                                                >Saúde</a
                                            >
                                        </li>
                                        <li class="nav-item mb-2">
                                            <a
                                                class="list-group-item nav-link list-group-item-action"
                                                @click="aba = 'educacao'"
                                                :class="aba == 'educacao' ? 'active' : ''"
                                                >Educação</a
                                            >
                                        </li>
                                        <li class="nav-item mb-2">
                                            <a
                                                class="list-group-item nav-link list-group-item-action"
                                                @click="aba = 'profissionalizacao'"
                                                :class="
                                                    aba == 'profissionalizacao'
                                                        ? 'active'
                                                        : ''
                                                "
                                                >Profissionalização</a
                                            >
                                        </li>
                                        <li class="nav-item mb-2">
                                            <a
                                                class="list-group-item nav-link list-group-item-action"
                                                @click="aba = 'arte'"
                                                :class="aba == 'arte' ? 'active' : ''"
                                                >Arte, Cultura, Esporte E Lazer</a
                                            >
                                        </li>
                                        <li class="nav-item mb-2">
                                            <a
                                                class="list-group-item nav-link list-group-item-action"
                                                @click="aba = 'aspecto'"
                                                :class="aba == 'aspecto' ? 'active' : ''"
                                                >Aspectos Sociofamiliares</a
                                            >
                                        </li>
                                        <li class="nav-item mb-2">
                                            <a
                                                class="list-group-item nav-link list-group-item-action"
                                                @click="aba = 'condicao'"
                                                :class="aba == 'condicao' ? 'active' : ''"
                                                >Condições Socioeconômicas
                                            </a>
                                        </li>
                                        <li class="nav-item mb-2">
                                            <a
                                                class="list-group-item nav-link list-group-item-action"
                                                @click="aba = 'vulnerabilidade'"
                                                :class="
                                                    aba == 'vulnerabilidade' ? 'active' : ''
                                                "
                                                >Vulnerabilidade e Riscos</a
                                            >
                                        </li>
                                        <li class="nav-item mb-2">
                                            <a
                                                class="list-group-item nav-link list-group-item-action"
                                                @click="aba = 'autonomia'"
                                                :class="aba == 'autonomia' ? 'active' : ''"
                                                >Autonomia / autoestima / identidade
                                            </a>
                                        </li>
                                        <li class="nav-item mb-2">
                                            <a
                                                class="list-group-item nav-link list-group-item-action"
                                                @click="aba = 'preparacao'"
                                                :class="aba == 'preparacao' ? 'active' : ''"
                                                >Preparação para desligamento</a
                                            >
                                        </li>
                                    </ul>
                                    <div class="col-md-9">
                                        <div v-show="aba == 'documental'">
                                            <div class="row">
                                                <h4 class="px-3">Situação Documental</h4>
                                                <form-calendar
                                                    label="Prazo"
                                                    v-model="metaPessoaSelecionada.documental_prazo"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="
                                                        metaPessoaSelecionada.documental_situacao_atual
                                                    "
                                                    label="Situação Atual"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.documental_meta"
                                                    label="Objetivo/Meta"
                                                />
                                            </div>
                                        </div>
                                        <div v-show="aba == 'processual'">
                                            <div class="row">
                                                <h4 class="px-3">Situação Processual</h4>
                                                <form-calendar
                                                    label="Prazo"
                                                    v-model="metaPessoaSelecionada.processual_prazo"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="
                                                        metaPessoaSelecionada.processual_situacao_atual
                                                    "
                                                    label="Situação Atual"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.processual_meta"
                                                    label="Objetivo/Meta"
                                                />
                                            </div>
                                        </div>
                                        <div v-show="aba == 'saude'">
                                            <div class="row">
                                                <h4 class="px-3">Saúde</h4>
                                                <form-calendar
                                                    label="Prazo"
                                                    v-model="metaPessoaSelecionada.saude_prazo"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.saude_situacao_atual"
                                                    label="Situação Atual"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.saude_meta"
                                                    label="Objetivo/Meta"
                                                />
                                            </div>
                                        </div>
                                        <div v-show="aba == 'educacao'">
                                            <div class="row">
                                                <h4 class="px-3">Educação</h4>
                                                <form-calendar
                                                    label="Prazo"
                                                    v-model="metaPessoaSelecionada.educacao_prazo"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="
                                                        metaPessoaSelecionada.educacao_situacao_atual
                                                    "
                                                    label="Situação Atual"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.educacao_meta"
                                                    label="Objetivo/Meta"
                                                />
                                            </div>
                                        </div>
                                        <div v-show="aba == 'profissionalizacao'">
                                            <div class="row">
                                                <h4 class="px-3">Profissionalização</h4>
                                                <form-calendar
                                                    label="Prazo"
                                                    v-model="
                                                        metaPessoaSelecionada.profissionalizacao_prazo
                                                    "
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="
                                                        metaPessoaSelecionada.profissionalizacao_situacao_atual
                                                    "
                                                    label="Situação Atual"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="
                                                        metaPessoaSelecionada.profissionalizacao_meta
                                                    "
                                                    label="Objetivo/Meta"
                                                />
                                            </div>
                                        </div>
                                        <div v-show="aba == 'arte'">
                                            <div class="row">
                                                <h4 class="px-3">
                                                    Arte, Cultura, Esporte E Lazer
                                                </h4>
                                                <form-calendar
                                                    label="Prazo"
                                                    v-model="metaPessoaSelecionada.arte_prazo"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.arte_situacao_atual"
                                                    label="Situação Atual"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.arte_meta"
                                                    label="Objetivo/Meta"
                                                />
                                            </div>
                                        </div>
                                        <div v-show="aba == 'aspecto'">
                                            <div class="row">
                                                <h4 class="px-3">
                                                    Aspectos Sociofamiliares
                                                </h4>
                                                <form-calendar
                                                    label="Prazo"
                                                    v-model="metaPessoaSelecionada.aspecto_prazo"
                                                />
                                                <form-select
                                                    v-model="metaPessoaSelecionada.possui_rede_apoio"
                                                    :itens="$root.arrays.pergunta"
                                                    label="Possui rede de apoio (pessoas/grupos que prestam algum tipo de suporte)?"
                                                />
                                            </div>

                                            <form @submit.prevent="cadastarPessoaReferencia" ref="addItem">
                                                <div class="row">
                                                    <form-input 
                                                        v-model="nome" 
                                                        label="Nome Completo" 
                                                        :required="true" 
                                                    />
                                                    <form-input
                                                        v-model="parentesco"
                                                        label="Parentesco / Tipo de Relação"
                                                        grid="6"
                                                        :required="true"
                                                    />
                                                    <form-input 
                                                        label="Idade" 
                                                        v-model="idade" 
                                                        type="number"
                                                        grid="6"
                                                    />
                                                    <form-input
                                                        v-model="telefone"
                                                        label="Telefone"
                                                        v-mask="'(##) # ####-####'"
                                                        placeholder="(00) 0 0000-0000"
                                                        grid="6"
                                                    />
                                                    <form-input 
                                                        label="E-mail" 
                                                        v-model="email" 
                                                        type="text"
                                                        grid="6"
                                                    />
                                                    <form-input 
                                                        label="Endereço" 
                                                        v-model="endereco" 
                                                        type="text"
                                                    />
                                                    <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end">
                                                        <button class="btn btn-primary m-0" data-style="zoom-in" type="submit">
                                                            Cadastrar
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                                
                                            <div class="row">
                                                <div class="col-12" v-if="pessoaReferencia.filter(p => p.tipo_cadastro === 'Sociofamiliar').length > 0">
                                                    <label class="d-block font-weight-bold mb-3">
                                                        Relação de Sociofamiliares: 
                                                    </label>

                                                    <table class="table table-sm border table-bordered mb-3" v-for="(pessoa, index) in pessoaReferencia.filter(p => p.tipo_cadastro === 'Sociofamiliar')">
                                                        <tbody>
                                                            <tr>
                                                                <td class="py-0" colspan="2">
                                                                    Nome Completo: <b>{{ pessoa.nome }}</b>
                                                                    <a
                                                                        title="Excluir"
                                                                        @click="excluirPessoa(pessoa.id, index)"
                                                                        class="float-right px-2 mb-0 text-danger "
                                                                    >
                                                                        <i class="mdi mdi-close"></i>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="py-0">
                                                                    Parentesco/ posição Familiar:
                                                                    <b>{{ pessoa.parentesco }}</b>
                                                                </td>
                                                                <td class="py-0">
                                                                    Idade:
                                                                    <b>{{ pessoa.idade }}</b>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="col-12" v-else>
                                                    <h4 class="text-secondary">
                                                        <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                                                        Nada salvo aqui.
                                                    </h4>
                                                </div>
                                                <form-input
                                                    v-model="metaPessoaSelecionada.intervencoes_sociofamiliares"
                                                    label="Intervenção e Percepção do Profissional referente aos aspectos sociofamiliares"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.text_equipe_suas"
                                                    label="Percepção da equipe SUAS"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.aspecto_situacao_atual"
                                                    label="Situação Atual"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.aspecto_meta"
                                                    label="Objetivo/Meta"
                                                />
                                            </div>
                                        </div>
                                        <div v-show="aba == 'condicao'">
                                            <div class="row">
                                                <h4 class="px-3">
                                                    Condições Socioeconômicas
                                                </h4>
                                                <form-calendar
                                                    label="Prazo"
                                                    v-model="metaPessoaSelecionada.condicao_prazo"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="
                                                        metaPessoaSelecionada.condicao_situacao_atual
                                                    "
                                                    label="Situação Atual"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.condicao_meta"
                                                    label="Objetivo/Meta"
                                                />
                                            </div>
                                        </div>
                                        <div v-show="aba == 'vulnerabilidade'">
                                            <div class="row">
                                                <h4 class="px-3">
                                                    Vulnerabilidade e Riscos
                                                </h4>
                                                <form-calendar
                                                    label="Prazo"
                                                    v-model="
                                                        metaPessoaSelecionada.vulnerabildiade_prazo
                                                    "
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="
                                                        metaPessoaSelecionada.vulnerabildiade_situacao_atual
                                                    "
                                                    label="Situação Atual"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.vulnerabildiade_meta"
                                                    label="Objetivo/Meta"
                                                />
                                            </div>
                                        </div>
                                        <div v-show="aba == 'autonomia'">
                                            <div class="row">
                                                <h4 class="px-3">
                                                    Autonomia / autoestima / identidade
                                                </h4>
                                                <form-calendar
                                                    label="Prazo"
                                                    v-model="metaPessoaSelecionada.autonomia_prazo"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="
                                                        metaPessoaSelecionada.autonomia_situacao_atual
                                                    "
                                                    label="Situação Atual"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.autonomia_meta"
                                                    label="Objetivo/Meta"
                                                />
                                            </div>
                                        </div>
                                        <div v-show="aba == 'preparacao'">
                                            <div class="row">
                                                <h4 class="px-3">
                                                    Preparação para desligamento
                                                </h4>
                                                <form-calendar
                                                    label="Prazo"
                                                    v-model="metaPessoaSelecionada.desligamento_prazo"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="
                                                        metaPessoaSelecionada.desligamento_situacao_atual
                                                    "
                                                    label="Situação Atual"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.desligamento_meta"
                                                    label="Objetivo/Meta"
                                                />
                                                <form-input
                                                    v-model="metaPessoaSelecionada.data_desligamento"
                                                    label="Data do Desligamento"
                                                    grid="6"
                                                    type="date"
                                                />
                                                <form-select
                                                    v-model="metaPessoaSelecionada.motivo_desligamento"
                                                    :itens="$root.arrays.motivo_desligamento_acolhimento"
                                                    label="Motivo do Desligamento"
                                                    grid="6"
                                                />
                                                <form-input
                                                    v-model="metaPessoaSelecionada.desc_motivo_desligamento"
                                                    label="Descreva o motivo do desligamento"
                                                    type="text"
                                                    v-show="mostrarDescMotivoDesligamentoPessoa"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.dados_da_rede_socioassistencial"
                                                    label="Dados da rede socioassistencial e intersetorial para acompanhamento: local(s), serviço(s), programa(s)"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.acao_repactuada"
                                                    label="Ações pactuadas no período pós-acolhimento e prazo(s)"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.rede_apoio_contato"
                                                    label="Rede de apoio para contato"
                                                />
                                                <form-textarea-editor
                                                    class="mt-3"
                                                    v-model="metaPessoaSelecionada.observacoes_desligamento"
                                                    label="Observações"
                                                />
                                            </div>
                                        </div>
                                        <div class="row px-2 d-flex justify-content-end">
                                            <button
                                                class="btn btn-success btn-submit"
                                                data-style="zoom-in"
                                                @click="submit"
                                                type="submit"
                                            >
                                                <i class="mdi mdi-content-save" />
                                                {{ $t("Salvar") }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            metaIdoso: {
                idoso: {
                documental_prazo: "",
                documental_situacao_atual: "",
                documental_meta: "",
                processual_prazo: "",
                processual_situacao_atual: "",
                processual_meta: "",
                saude_prazo: "",
                saude_situacao_atual: "",
                saude_meta: "",
                educacao_prazo: "",
                educacao_situacao_atual: "",
                educacao_meta: "",
                profissionalizacao_prazo: "", 
                profissionalizacao_situacao_atual: "", 
                profissionalizacao_meta: "",
                arte_prazo: "",
                arte_situacao_atual: "",
                arte_meta: "",
                aspecto_prazo: "",
                aspecto_situacao_atual: "",
                aspecto_meta: "",
                condicao_prazo: "",
                condicao_situacao_atual: "",
                condicao_meta: "",
                vulnerabildiade_prazo: "",
                vulnerabildiade_situacao_atual: "",
                vulnerabildiade_meta: "",
                desligamento_prazo: "",
                desligamento_situacao_atual: "",
                desligamento_meta: ""
                },
                pessoasVinculadas: []
            },
            pessoaReferencia: [],
            pessoaSelecionada: null,
            metaPessoaSelecionada: null,
            nome: "",
            parentesco: "",
            idade: "",
            telefone: "",
            email: "",
            endereco: "",
            loading: false,
            aba: "documental",
        };
    },
    mounted() {
        if (this.item.metaIdoso) {
            this.metaIdoso = {
                ...this.metaIdoso, // valores padrão
                ...this.item.metaIdoso,
                idoso: {
                    ...this.metaIdoso.idoso, // valores padrão
                    ...(this.item.metaIdoso.idoso || {}), // sobrescreve se existir
                }
            };
        }
        if (this.item.pessoaReferencia != null) {
            this.pessoaReferencia = this.item.pessoaReferencia;  
        }
    }, 
    watch: {
        item(n, o) {
            
            if (this.item.metaIdoso) {
                this.metaIdoso = {
                    ...this.metaIdoso,
                    ...this.item.metaIdoso, 
                    idoso: {
                        ...this.metaIdoso.idoso,
                        ...(this.item.metaIdoso.idoso || {}) 
                    }
                };
            }

            if (this.item.pessoaReferencia != null) {
                this.pessoaReferencia = this.item.pessoaReferencia;
            }
        },
        'metaIdoso.idoso.motivo_desligamento'(novoValor) {
            if (novoValor != 17) {
                this.metaIdoso.idoso.desc_motivo_desligamento = null;
            }
        },
        'metaPessoaSelecionada.motivo_desligamento'(novoValor) {
            if (novoValor != 17) {
                this.metaPessoaSelecionada.desc_motivo_desligamento = null;
            }
        },
    },
    computed: {
        todasPessoas() {
            const pessoaPrincipal = {
                id: 'principal',
                nome: this.item.nome_acolhido,
                idade: this.calcularIdade(this.item.nascimento),
                parentesco: 'Acolhido(a)',
                tipo_cadastro: 'Principal',
            };

            const vinculados = this.pessoaReferencia.filter(
                p => p.tipo_cadastro === 'Familiar' || p.tipo_cadastro === 'Crianca'
            );

            return [pessoaPrincipal, ...vinculados];
        },
        mostrarDescDesligamento() {
            return this.metaIdoso.idoso.motivo_desligamento === 17;
        },
        mostrarDescMotivoDesligamentoPessoa(pessoa) {
            return this.metaPessoaSelecionada?.motivo_desligamento === 17;
        },
        isIdoso() {

            const hoje = moment();
            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
            const idade = hoje.diff(nascimento, 'years');

            // Se existir público alvo, verifica se é 8, senão usa idade para decidir
            return this.item.solicitacao?.publico_alvo_id === 8 || idade >= 60;
        }
    },
    methods: {
        calcularIdade(dataNasc) {
            if (!dataNasc) return null;
            const hoje = new Date();
            const nasc = new Date(dataNasc);
            let idade = hoje.getFullYear() - nasc.getFullYear();
            const m = hoje.getMonth() - nasc.getMonth();
            if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) {
                idade--;
            }
            return idade;
        },
        selecionarPessoa(pessoa) {

            this.pessoaSelecionada = pessoa;

            if (pessoa.tipo_cadastro === 'Principal') {

                this.metaPessoaSelecionada = { ...this.metaIdoso.idoso };

            }else{
                
                const dados = this.metaIdoso.pessoasVinculadas.find(
                    p => p.pessoa_referencia_id === pessoa.id
                );
                this.metaPessoaSelecionada = dados
                    ? { ...dados }
                    : {
                        pessoa_referencia_id: pessoa.id,
                        documental_prazo: "",
                        documental_situacao_atual: "",
                        documental_meta: "",
                        processual_prazo: "",
                        processual_situacao_atual: "",
                        processual_meta: "",
                        saude_prazo: "",
                        saude_situacao_atual: "",
                        saude_meta: "",
                        educacao_prazo: "",
                        educacao_situacao_atual: "",
                        educacao_meta: "",
                        profissionalizacao_prazo: "",
                        profissionalizacao_situacao_atual: "",
                        profissionalizacao_meta: "",
                        arte_prazo: "",
                        arte_situacao_atual: "",
                        arte_meta: "",
                        aspecto_prazo: "",
                        aspecto_situacao_atual: "",
                        aspecto_meta: "",
                        condicao_prazo: "",
                        condicao_situacao_atual: "",
                        condicao_meta: "",
                        vulnerabildiade_prazo: "",
                        vulnerabildiade_situacao_atual: "",
                        vulnerabildiade_meta: "",
                        desligamento_prazo: "",
                        desligamento_situacao_atual: "",
                        desligamento_meta: ""
                    };

            }

        },
        submit() {
            if (this.pessoaSelecionada && this.metaPessoaSelecionada) {
                if (this.pessoaSelecionada.tipo_cadastro === 'Principal') {
                    // Preenche diretamente o objeto do idoso
                    this.metaIdoso.idoso = { ...this.metaPessoaSelecionada };
                } else {
                    // Preenche a propriedade da pessoa vinculada
                    this.pessoaSelecionada.meta = { ...this.metaPessoaSelecionada };

                    // Atualiza ou adiciona à lista de pessoasVinculadas
                    const idx = this.metaIdoso.pessoasVinculadas.findIndex(
                        p => p.pessoa_referencia_id === this.pessoaSelecionada.id
                    );

                    const pessoa = {
                        ...this.pessoaSelecionada,
                        pessoa_referencia_id: this.pessoaSelecionada.id
                    };

                    if (idx !== -1) {
                        this.metaIdoso.pessoasVinculadas.splice(idx, 1, pessoa);
                    } else {
                        this.metaIdoso.pessoasVinculadas.push(pessoa);
                    }
                }
            }

            this.item.metaIdoso = this.metaIdoso;
            this.$emit("submit");
            
        },
        cadastarPessoaReferencia() {
            this.loading = true;
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            axios
                .post(
                    `api/dashboard/acolhimento/idoso/storepessoa`,
                    {
                        nome: this.nome,
                        parentesco: this.parentesco || "-",
                        idade: this.idade,
                        telefone: this.telefone || "-",
                        email: this.email || "-",
                        endereco: this.endereco || "-",
                        acolhimento_id: this.item.id,
                        tipo_cadastro: "Sociofamiliar"
                    },
                    {
                        header: { "Content-Type": "multipart/form-data" },
                        onUploadProgress: event => {
                            let progress = Math.round(
                                (event.loaded * 100) / event.total
                            );
                            this.progressCompleted = progress;
                        }
                    }
                )
                .then(response => {
                    ladda.stop();

                    this.$snack.success({
                        button: false,
                        text: response.data.data.message
                    });
                    this.$emit("reload");
                })
                .finally(() => {
                    this.limpar();
                });
        },
        excluirPessoa(id) {
            swal.fire({
                text: "Aguarde a ação ser finalizada.",
                icon: "warning",
                showConfirmButton: false,
                timer: 1500
            });
            axios
                .get(`api/dashboard/acolhimento/idoso/pessoa/excluir/${id}`)
                .then(response => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message
                    });
                    this.$emit("reload");
                });
        },
        verificarValueArray(value, array, valueIsArray = false) {
            if (valueIsArray && value) {
                var a = "";
                for (var i = 0; i < value.length; i++) {
                    const result = array.filter(item => item.id == value[i]);
                    a += result[0].value + (i < value.length - 1 ? "," : "");
                }

                return a;
            } else {
                const result = array.filter(item => item.id == value);
                return result[0] ? result[0].value : "";
            }
        },
        limpar() {
            this.nome = "";
            this.parentesco = "";
            this.idade = "";
            this.telefone = "";
            this.email = "";
            this.endereco = "";
            this.loading = false;
        }
    },
};
</script>
<style scoped>
li.nav-item mb-2 a {
    cursor: pointer !important;
}
</style>
